import React from "react"
import { Link as LinkRouter } from "react-router-dom"

import { Button } from "@material-ui/core"
import { ArrowForwardIos, BarChart } from "@material-ui/icons"
import useStyles from "@/pages/Admin/TrackableLinks/TrackableLinksTable/RedirectTrackableLinkMetricsTableButton/styles"
import newColors from "@/styles/newColors"

type RedirectTrackableLinkMetricsTableButtonProps = {
	redirectLink: string
}

const RedirectTrackableLinkMetricsTableButton: React.FC<RedirectTrackableLinkMetricsTableButtonProps> = (props) => {
	const { redirectLink } = props
	const classes = useStyles()

	return (
		<Button
			variant="contained"
			className={classes.button}
			size="small"
			component={LinkRouter}
			to={redirectLink}
			startIcon={
				<BarChart
					style={{ fontSize: 16, color: newColors.green[500] }}
				/>
			}
			endIcon={
				<ArrowForwardIos
					style={{ fontSize: 12 }}
				/>
			}
		>
			Ver métricas
		</Button>
	)
}

export default RedirectTrackableLinkMetricsTableButton
